import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
//services
import { getPaymentMethodsTypes } from 'modules/accommodations/features/reservations/api';

export const useQueryPaymentTypeSidebar = () => {
  const {
    error: errPaymentMethods,
    data: dataPaymentMethods,
    isLoading: isLoadingPaymentMethods,
  } = useQuery([QUERY_KEYS.UNITS_PAYMENT_METHOD_TYPES], getPaymentMethodsTypes);

  return {
    errPaymentMethods,
    isLoadingPaymentMethods,
    paymentMethods: dataPaymentMethods,
  };
};
